/* BLRB Offer JS — v10.0 Offer Funnel
   Scroll reveal, FAQ, Marquee, Floating CTA, Tier selection, Subscribe toggle */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    /* --- Scroll Reveal --- */
    var reveals = document.querySelectorAll('.offer-reveal');
    if (reveals.length) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, { rootMargin: '0px 0px -60px 0px' });
      reveals.forEach(function(el) { observer.observe(el); });
    }

    /* --- FAQ Accordion --- */
    var faqItems = document.querySelectorAll('.offer-faq-item__question');
    faqItems.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.offer-faq-item');
        var wasActive = item.classList.contains('active');
        document.querySelectorAll('.offer-faq-item.active').forEach(function(el) {
          el.classList.remove('active');
        });
        if (!wasActive) item.classList.add('active');
      });
    });

    /* --- Marquee Clone --- */
    var marqueeTrack = document.querySelector('.offer-marquee__track');
    if (marqueeTrack) {
      marqueeTrack.innerHTML += marqueeTrack.innerHTML;
    }

    /* --- Floating CTA --- */
    var floatingCta = document.querySelector('.offer-floating-cta');
    var heroSection = document.getElementById('offer-hero');
    var floatBounced = false;
    if (floatingCta) {
      var threshold = 600;
      if (heroSection) {
        threshold = heroSection.offsetTop + heroSection.offsetHeight;
      }
      window.addEventListener('scroll', function() {
        if (window.pageYOffset > threshold) {
          floatingCta.classList.add('visible');
          if (!floatBounced) {
            floatBounced = true;
            floatingCta.classList.add('offer-floating-cta--bounce');
          }
        } else {
          floatingCta.classList.remove('visible');
        }
      }, { passive: true });
    }

    /* --- Countdown Timer (48h rolling, persisted in localStorage) --- */
    var cdEl = document.querySelector('[data-offer-countdown]');
    if (cdEl) {
      var cdKey = 'offer_cd_end';
      var cdEnd = parseInt(localStorage.getItem(cdKey), 10);
      var now = Date.now();
      if (!cdEnd || cdEnd <= now) {
        cdEnd = now + 48 * 60 * 60 * 1000;
        localStorage.setItem(cdKey, cdEnd);
      }
      var cdHours = cdEl.querySelector('[data-cd-hours]');
      var cdMins = cdEl.querySelector('[data-cd-mins]');
      var cdSecs = cdEl.querySelector('[data-cd-secs]');
      function tickCountdown() {
        var diff = Math.max(0, cdEnd - Date.now());
        if (diff <= 0) {
          cdEnd = Date.now() + 48 * 60 * 60 * 1000;
          localStorage.setItem(cdKey, cdEnd);
          diff = cdEnd - Date.now();
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (cdHours) cdHours.textContent = h < 10 ? '0' + h : h;
        if (cdMins) cdMins.textContent = m < 10 ? '0' + m : m;
        if (cdSecs) cdSecs.textContent = s < 10 ? '0' + s : s;
      }
      tickCountdown();
      setInterval(tickCountdown, 1000);
    }

    /* --- Smooth scroll for offer anchor links --- */
    document.querySelectorAll('[data-offer-anchor]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = link.getAttribute('href');
        var hash = href.split('#')[1];
        if (!hash) return;
        var target = document.getElementById(hash);
        if (!target) return;
        e.preventDefault();
        var drawerDetails = document.getElementById('Details-menu-drawer-container');
        if (drawerDetails && drawerDetails.hasAttribute('open')) {
          drawerDetails.removeAttribute('open');
        }
        setTimeout(function() {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      });
    });

    /* ==========================================================================
       Tier Selection System
       ========================================================================== */
    var tierCards = document.querySelectorAll('.offer-tiers__card');
    var tierCta = document.getElementById('offer-tiers-cta');
    var giftVisuals = document.querySelectorAll('.offer-tiers__gift-visual');
    var giftTotalEl = document.querySelector('[data-gift-total]');
    var floatTier = document.querySelector('[data-float-tier]');
    var floatDetail = document.querySelector('[data-float-detail]');
    var currentMode = 'subscribe'; // 'subscribe' or 'onetime'

    function getSelectedCard() {
      return document.querySelector('.offer-tiers__card--selected');
    }

    function selectTier(card) {
      // Remove selected from all
      tierCards.forEach(function(c) {
        c.classList.remove('offer-tiers__card--selected');
      });
      card.classList.add('offer-tiers__card--selected');
      updatePrices();
      updateGiftStrip();
      updateGiftVisuals();
      updateCta();
      updateFloatingCta();
      updateNudge();
    }

    function updatePrices() {
      tierCards.forEach(function(card) {
        var priceEl = card.querySelector('[data-tier-price]');
        var originalEl = card.querySelector('[data-tier-original]');
        if (!priceEl) return;
        if (currentMode === 'subscribe') {
          priceEl.textContent = card.dataset.subPrice || '';
          if (originalEl) originalEl.textContent = card.dataset.subOriginal || '';
        } else {
          priceEl.textContent = card.dataset.onePrice || '';
          if (originalEl) originalEl.textContent = card.dataset.oneOriginal || '';
        }
      });
    }

    function updateGiftStrip() {
      var selected = getSelectedCard();
      if (!selected) return;
      // Update summary text (tier name + price)
      var valueAmountEl = document.querySelector('[data-value-amount]');
      var valueTierEl = document.querySelector('[data-value-tier]');
      if (valueAmountEl) {
        var price = currentMode === 'subscribe'
          ? (selected.dataset.subPrice || '')
          : (selected.dataset.onePrice || '');
        valueAmountEl.textContent = price;
      }
      if (valueTierEl) {
        valueTierEl.textContent = selected.dataset.tierName || '';
      }
    }

    function updateGiftVisuals() {
      var selected = getSelectedCard();
      if (!selected || !giftVisuals.length) return;
      var giftCount = parseInt(selected.dataset.giftCount, 10) || 0;
      var unlocked = 0;
      giftVisuals.forEach(function(gift) {
        var idx = parseInt(gift.dataset.giftIndex, 10);
        var lockEl = gift.querySelector('[data-gift-lock]');
        if (idx < giftCount) {
          gift.classList.add('offer-tiers__gift-visual--unlocked');
          gift.classList.remove('offer-tiers__gift-visual--locked');
          if (lockEl) lockEl.style.display = 'none';
          unlocked++;
        } else {
          gift.classList.remove('offer-tiers__gift-visual--unlocked');
          gift.classList.add('offer-tiers__gift-visual--locked');
          if (lockEl) lockEl.style.display = '';
        }
      });
      if (giftTotalEl) {
        if (unlocked === giftVisuals.length) {
          giftTotalEl.textContent = 'All gifts unlocked!';
          giftTotalEl.style.color = '#2D8F5E';
        } else {
          var remaining = giftVisuals.length - unlocked;
          giftTotalEl.textContent = 'Upgrade to unlock ' + remaining + ' more';
          giftTotalEl.style.color = '';
        }
      }
    }

    function updateCta() {
      var selected = getSelectedCard();
      if (!selected || !tierCta) return;
      var name = selected.dataset.tierName || '';
      var price = currentMode === 'subscribe'
        ? (selected.dataset.subPrice || '')
        : (selected.dataset.onePrice || '');
      tierCta.textContent = 'Add ' + name + ' Bundle \u2014 ' + price;
    }

    function updateFloatingCta() {
      var selected = getSelectedCard();
      if (!selected) return;
      var name = selected.dataset.tierName || '';
      var price = currentMode === 'subscribe'
        ? (selected.dataset.subPrice || '')
        : (selected.dataset.onePrice || '');
      if (floatTier) floatTier.textContent = name + ' Bundle';
      if (floatDetail) floatDetail.textContent = price + ' · Free Shipping';
    }

    /* --- Reactive Upgrade Nudge --- */
    function updateNudge() {
      var nudges = document.querySelectorAll('[data-upgrade-nudge]');
      if (!nudges.length) return;
      var selected = getSelectedCard();
      if (!selected) return;

      var idx = parseInt(selected.dataset.tierIndex, 10);
      var allCards = Array.prototype.slice.call(tierCards);
      // Find next tier up (higher index = better deal)
      var nextCard = null;
      for (var i = 0; i < allCards.length; i++) {
        if (parseInt(allCards[i].dataset.tierIndex, 10) > idx) {
          nextCard = allCards[i];
          break;
        }
      }
      // Find the max tier
      var maxCard = allCards[allCards.length - 1];
      var isMax = !nextCard || idx >= parseInt(maxCard.dataset.tierIndex, 10);

      nudges.forEach(function(nudge) {
        var textEl = nudge.querySelector('[data-nudge-text]');
        var arrowEl = nudge.querySelector('.offer-tiers__nudge-arrow');
        if (!textEl) return;

        if (isMax) {
          // Best tier selected — affirm the choice
          textEl.innerHTML = '&#10003; You picked the <strong>best deal</strong> \u2014 maximum savings + <strong>all ' + (selected.dataset.giftCount || '4') + ' free gifts</strong>';
          nudge.classList.add('offer-tiers__upgrade-nudge--best');
          nudge.classList.remove('offer-tiers__upgrade-nudge--upsell');
          if (arrowEl) arrowEl.style.display = 'none';
        } else {
          var nextName = nextCard.dataset.tierName || '';
          var nextGifts = nextCard.dataset.giftCount || '';
          var nextSavings = nextCard.dataset.savingsText || '';
          textEl.innerHTML = 'Upgrade to <strong>' + nextName + '</strong> for <strong>' + nextGifts + ' free gifts</strong> + <strong>' + nextSavings + '</strong>';
          nudge.classList.remove('offer-tiers__upgrade-nudge--best');
          nudge.classList.add('offer-tiers__upgrade-nudge--upsell');
          if (arrowEl) arrowEl.style.display = '';
        }

        // Trigger re-entrance animation
        nudge.classList.remove('offer-tiers__upgrade-nudge--animate');
        void nudge.offsetWidth; // force reflow
        nudge.classList.add('offer-tiers__upgrade-nudge--animate');
      });
    }

    // Tier card click
    tierCards.forEach(function(card) {
      card.addEventListener('click', function() {
        selectTier(card);
      });
    });

    // Subscribe-first mode toggle (text link)
    var modeLink = document.querySelector('.offer-tiers__onetime-link');
    if (modeLink) {
      modeLink.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentMode === 'subscribe') {
          currentMode = 'onetime';
          modeLink.innerHTML = 'switch to subscribe &amp; save &larr;';
        } else {
          currentMode = 'subscribe';
          modeLink.innerHTML = 'or buy once &rarr;';
        }
        updatePrices();
        updateCta();
        updateFloatingCta();
      });
    }

    // Initialize on load
    var preselected = document.querySelector('.offer-tiers__card--selected');
    if (preselected) {
      updatePrices();
      updateGiftStrip();
      updateGiftVisuals();
      updateCta();
      updateFloatingCta();
      updateNudge();
    }

    /* ==========================================================================
       AJAX Add-to-Cart Handler (v10.2)
       ========================================================================== */
    var tierCtaBtn = document.getElementById('offer-tiers-cta');
    if (tierCtaBtn) {
      tierCtaBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var selected = getSelectedCard();
        if (!selected) return;

        var variantId = selected.dataset.variantId;
        if (!variantId) return;

        tierCtaBtn.classList.add('offer-btn--loading');
        tierCtaBtn.disabled = true;

        var mainItem = {
          id: variantId,
          quantity: parseInt(selected.dataset.quantity, 10) || 1
        };

        if (currentMode === 'subscribe' && selected.dataset.sellingPlan) {
          mainItem.selling_plan = selected.dataset.sellingPlan;
        }

        var items = [mainItem];

        // Free gifts: only attached to subscription purchases
        if (currentMode === 'subscribe' && selected.dataset.giftVariantIds) {
          selected.dataset.giftVariantIds.split('|').forEach(function(gid) {
            var cleaned = (gid || '').trim();
            if (cleaned) items.push({ id: cleaned, quantity: 1 });
          });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('Cart error');
          return r.json();
        })
        .then(function() {
          if (window.__offerConfetti) window.__offerConfetti(tierCtaBtn);
          setTimeout(function() { window.location.href = '/checkout'; }, 900);
        })
        .catch(function() {
          tierCtaBtn.classList.remove('offer-btn--loading');
          tierCtaBtn.disabled = false;
          alert('Error adding to cart. Please try again.');
        });
      });
    }

    /* ==========================================================================
       PDP Subscription Pre-Check (v10.2)
       Auto-check subscription checkbox on product page load
       ========================================================================== */
    var subCheckbox = document.querySelector('.new-sub-input-js');
    if (subCheckbox && !subCheckbox.checked) {
      subCheckbox.checked = true;
      subCheckbox.dispatchEvent(new Event('change'));
    }

    /* ==========================================================================
       PDP Gallery Thumbnail Switcher (v10.3)
       ========================================================================== */
    var pdpThumbs = document.querySelectorAll('.offer-pdp__thumb');
    var pdpMainImg = document.getElementById('offer-pdp-main-img');
    if (pdpThumbs.length && pdpMainImg) {
      pdpThumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          pdpThumbs.forEach(function(t) { t.classList.remove('offer-pdp__thumb--active'); });
          thumb.classList.add('offer-pdp__thumb--active');
          pdpMainImg.src = thumb.dataset.mediaSrc;
        });
      });
    }

    /* ==========================================================================
       PDP Tabs Accordion (v10.3)
       ========================================================================== */
    document.querySelectorAll('.offer-pdp__tab-header').forEach(function(header) {
      header.addEventListener('click', function() {
        var tab = header.closest('.offer-pdp__tab');
        var wasOpen = tab.classList.contains('offer-pdp__tab--open');
        tab.classList.toggle('offer-pdp__tab--open');
        header.setAttribute('aria-expanded', !wasOpen);
      });
    });

    /* ==========================================================================
       CONVERSION TRICKS — Social Proof, Scarcity, Urgency (v10.4)
       ========================================================================== */

    /* --- 1. Social Proof Toast Notifications --- */
    (function() {
      var toastNames = [
        'Sarah M. from Austin, TX', 'David K. from Miami, FL',
        'Linda P. from Portland, OR', 'James R. from Denver, CO',
        'Maria C. from San Diego, CA', 'Tom W. from Chicago, IL',
        'Emily H. from Nashville, TN', 'Robert L. from Seattle, WA',
        'Jessica B. from Atlanta, GA', 'Michael S. from New York, NY'
      ];
      var toastProducts = [
        'Best Value Bundle (3 Bottles)', 'Most Popular Bundle (2 Bottles)',
        'Starter Bundle (1 Bottle)', 'Best Value Bundle (3 Bottles)',
        'Most Popular Bundle (2 Bottles)'
      ];
      var toastTimes = ['2 minutes ago', '5 minutes ago', '8 minutes ago', '12 minutes ago', '15 minutes ago', 'just now', '3 minutes ago', '7 minutes ago'];

      var toastContainer = document.createElement('div');
      toastContainer.className = 'offer-toast-container';
      document.body.appendChild(toastContainer);

      var toastIndex = 0;
      function showToast() {
        var name = toastNames[toastIndex % toastNames.length];
        var product = toastProducts[toastIndex % toastProducts.length];
        var time = toastTimes[toastIndex % toastTimes.length];
        toastIndex++;
        var toast = document.createElement('div');
        toast.className = 'offer-toast';
        toast.innerHTML = '<div class="offer-toast__icon">\uD83D\uDED2</div><div class="offer-toast__body"><div class="offer-toast__name">' + name + '</div><div class="offer-toast__action">just purchased <strong>' + product + '</strong></div><div class="offer-toast__time">' + time + '</div></div><button class="offer-toast__close">&times;</button>';
        toastContainer.appendChild(toast);
        toast.querySelector('.offer-toast__close').addEventListener('click', function() {
          toast.classList.add('offer-toast--exit');
          setTimeout(function() { toast.remove(); }, 400);
        });
        setTimeout(function() {
          if (toast.parentNode) {
            toast.classList.add('offer-toast--exit');
            setTimeout(function() { toast.remove(); }, 400);
          }
        }, 5000);
      }
      setTimeout(function() {
        showToast();
        setInterval(function() { showToast(); }, 15000 + Math.random() * 10000);
      }, 8000);
    })();

    /* --- 2. Stats Counter Animation --- */
    (function() {
      var counters = document.querySelectorAll('[data-count-to]');
      if (!counters.length) return;
      var counterObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          if (el.dataset.counted) return;
          el.dataset.counted = '1';
          counterObserver.unobserve(el);
          var raw = el.dataset.countTo;
          var match = raw.match(/^([^0-9]*)([0-9][0-9,.]*)([^0-9]*)$/);
          if (!match) return;
          var prefix = match[1];
          var numStr = match[2];
          var suffix = match[3];
          var hasComma = numStr.indexOf(',') > -1;
          var hasDot = numStr.indexOf('.') > -1 && !hasComma;
          var target = parseFloat(numStr.replace(/,/g, ''));
          if (isNaN(target)) return;
          var decimals = 0;
          if (hasDot) { decimals = (numStr.split('.')[1] || '').length; }
          el.textContent = prefix + '0' + suffix;
          var duration = 2000;
          var startTime = null;
          function animate(ts) {
            if (!startTime) startTime = ts;
            var progress = Math.min((ts - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = target * eased;
            var formatted;
            if (decimals > 0) {
              formatted = current.toFixed(decimals);
            } else {
              formatted = Math.floor(current).toString();
              if (hasComma) formatted = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            el.textContent = prefix + formatted + suffix;
            if (progress < 1) requestAnimationFrame(animate);
          }
          requestAnimationFrame(animate);
        });
      }, { threshold: 0.3 });
      counters.forEach(function(el) { counterObserver.observe(el); });
    })();

    /* --- 3. Tier Countdown Bar --- */
    (function() {
      var tierSection = document.getElementById('offer-tiers');
      if (!tierSection) return;
      var tiersInner = tierSection.querySelector('.offer-container');
      if (!tiersInner) return;
      var bar = document.createElement('div');
      bar.className = 'offer-countdown-bar';
      bar.innerHTML = '<span class="offer-countdown-bar__icon">\uD83D\uDD25</span> <span class="offer-countdown-bar__text">Sale ends in <strong><span data-cd-bar-h>00</span>:<span data-cd-bar-m>00</span>:<span data-cd-bar-s>00</span></strong> \u2014 prices go up when timer hits zero!</span>';
      tiersInner.insertBefore(bar, tiersInner.firstChild);
      var cdKey = 'offer_cd_end';
      var cdEnd = parseInt(localStorage.getItem(cdKey), 10) || (Date.now() + 48 * 3600000);
      var bH = bar.querySelector('[data-cd-bar-h]');
      var bM = bar.querySelector('[data-cd-bar-m]');
      var bS = bar.querySelector('[data-cd-bar-s]');
      function tickBar() {
        var diff = Math.max(0, cdEnd - Date.now());
        if (diff <= 0) {
          cdEnd = Date.now() + 48 * 3600000;
          localStorage.setItem(cdKey, cdEnd);
          diff = cdEnd - Date.now();
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        bH.textContent = h < 10 ? '0' + h : h;
        bM.textContent = m < 10 ? '0' + m : m;
        bS.textContent = s < 10 ? '0' + s : s;
      }
      tickBar();
      setInterval(tickBar, 1000);
    })();

    /* --- 4. Live Viewer Count --- */
    (function() {
      var tierSection = document.getElementById('offer-tiers');
      if (!tierSection) return;
      var cta = tierSection.querySelector('.offer-tiers__summary');
      if (!cta) return;
      var viewerEl = document.createElement('div');
      viewerEl.className = 'offer-viewer-count';
      var baseCount = 28 + Math.floor(Math.random() * 35);
      viewerEl.innerHTML = '<span class="offer-viewer-count__dot"></span> <strong>' + baseCount + '</strong> people are viewing this right now';
      cta.parentNode.insertBefore(viewerEl, cta);
      setInterval(function() {
        baseCount += Math.floor(Math.random() * 5) - 2;
        if (baseCount < 24) baseCount = 24;
        if (baseCount > 68) baseCount = 68;
        viewerEl.querySelector('strong').textContent = baseCount;
      }, 3000 + Math.random() * 2000);
    })();

    /* --- 5. Stock Scarcity on Popular Tier --- */
    (function() {
      var featured = document.querySelector('.offer-tiers__card--featured');
      if (!featured) return;
      var stock = 7 + Math.floor(Math.random() * 6);
      var stockEl = document.createElement('div');
      stockEl.className = 'offer-stock-scarcity';
      stockEl.innerHTML = '<div class="offer-stock-scarcity__text">\u26A0\uFE0F Only <strong>' + stock + '</strong> left at this price!</div><div class="offer-stock-scarcity__bar"><div class="offer-stock-scarcity__fill" style="width:' + (stock / 30 * 100) + '%"></div></div>';
      featured.appendChild(stockEl);
      setInterval(function() {
        if (Math.random() > 0.6 && stock > 3) {
          stock--;
          stockEl.querySelector('strong').textContent = stock;
          stockEl.querySelector('.offer-stock-scarcity__fill').style.width = (stock / 30 * 100) + '%';
          if (stock <= 5) stockEl.classList.add('offer-stock-scarcity--critical');
        }
      }, 30000);
    })();

    /* --- 5b. Floating CTA Countdown --- */
    (function() {
      var fc = document.querySelector('[data-float-countdown]');
      if (!fc) return;
      var cdKey = 'offer_cd_end';
      var cdEnd = parseInt(localStorage.getItem(cdKey), 10) || (Date.now() + 48 * 3600000);
      var fH = fc.querySelector('[data-float-cd-h]');
      var fM = fc.querySelector('[data-float-cd-m]');
      var fS = fc.querySelector('[data-float-cd-s]');
      function tickFloat() {
        var diff = Math.max(0, cdEnd - Date.now());
        if (diff <= 0) {
          cdEnd = Date.now() + 48 * 3600000;
          localStorage.setItem(cdKey, cdEnd);
          diff = cdEnd - Date.now();
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        fH.textContent = h < 10 ? '0' + h : h;
        fM.textContent = m < 10 ? '0' + m : m;
        fS.textContent = s < 10 ? '0' + s : s;
      }
      tickFloat();
      setInterval(tickFloat, 1000);
    })();

    /* --- 6. Floating CTA Re-bounce --- */
    (function() {
      if (!floatingCta) return;
      setInterval(function() {
        if (floatingCta.classList.contains('visible')) {
          floatingCta.classList.remove('offer-floating-cta--bounce');
          void floatingCta.offsetWidth;
          floatingCta.classList.add('offer-floating-cta--bounce');
        }
      }, 30000);
    })();

    /* --- 7. Exit-Intent Popup --- */
    (function() {
      if (sessionStorage.getItem('offer_exit_shown')) return;
      var overlay = document.createElement('div');
      overlay.className = 'offer-exit-popup';
      overlay.innerHTML = '<div class="offer-exit-popup__card">' +
        '<button class="offer-exit-popup__close">&times;</button>' +
        '<div class="offer-exit-popup__emoji">\uD83D\uDE31</div>' +
        '<h3 class="offer-exit-popup__title">Wait! Don\'t miss out!</h3>' +
        '<p class="offer-exit-popup__text">Your <strong>40% discount + free gifts</strong> expire when this timer hits zero. Over <strong>2,847 customers</strong> love LyteBites \u2014 try it risk-free today.</p>' +
        '<a href="#offer-tiers" class="offer-exit-popup__btn">Claim My Discount \u2192</a>' +
        '<p class="offer-exit-popup__sub">\uD83D\uDEE1\uFE0F 30-Day Money-Back Guarantee \u00B7 Free Shipping</p>' +
        '</div>';
      document.body.appendChild(overlay);
      function showPopup() {
        sessionStorage.setItem('offer_exit_shown', '1');
        overlay.classList.add('offer-exit-popup--visible');
      }
      function closePopup() {
        overlay.classList.remove('offer-exit-popup--visible');
      }
      overlay.querySelector('.offer-exit-popup__close').addEventListener('click', closePopup);
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closePopup();
      });
      overlay.querySelector('.offer-exit-popup__btn').addEventListener('click', function(e) {
        e.preventDefault();
        closePopup();
        var t = document.getElementById('offer-tiers');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      document.addEventListener('mouseleave', function(e) {
        if (e.clientY < 10 && !sessionStorage.getItem('offer_exit_shown')) showPopup();
      });
      var lastScrollY = window.pageYOffset;
      window.addEventListener('scroll', function() {
        var cy = window.pageYOffset;
        if (cy < lastScrollY - 300 && cy < 200 && !sessionStorage.getItem('offer_exit_shown')) showPopup();
        lastScrollY = cy;
      }, { passive: true });
    })();

    /* --- 8. Add-to-Cart Confetti --- */
    (function() {
      var colors = ['#E84D1A', '#C4572A', '#2D8F5E', '#F5C842', '#FF6B6B', '#4ECDC4'];
      window.__offerConfetti = function(anchor) {
        var rect = anchor.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top;
        for (var i = 0; i < 40; i++) {
          var p = document.createElement('div');
          p.className = 'offer-confetti';
          p.style.backgroundColor = colors[i % colors.length];
          p.style.left = cx + 'px';
          p.style.top = cy + 'px';
          var angle = Math.random() * Math.PI * 2;
          var vel = 60 + Math.random() * 120;
          p.style.setProperty('--dx', (Math.cos(angle) * vel) + 'px');
          p.style.setProperty('--dy', (Math.sin(angle) * vel - 80) + 'px');
          p.style.setProperty('--r', (Math.random() * 720 - 360) + 'deg');
          document.body.appendChild(p);
          setTimeout(function(el) { el.remove(); }.bind(null, p), 1200);
        }
      };
    })();

    /* --- 9. Sticky Top Urgency Bar (scrolling marquee) --- */
    (function() {
      var bar = document.createElement('div');
      bar.className = 'offer-sticky-urgency';
      var msg = '\u26A1 FLASH SALE: 40% Off + Free Gifts \u00A0\u00A0\u00A0\u2022\u00A0\u00A0\u00A0 \uD83D\uDCE6 Free Shipping on All Bundles \u00A0\u00A0\u00A0\u2022\u00A0\u00A0\u00A0 \uD83D\uDEE1\uFE0F 30-Day Money-Back Guarantee \u00A0\u00A0\u00A0\u2022\u00A0\u00A0\u00A0 \uD83C\uDF1F 2,847+ 5-Star Reviews \u00A0\u00A0\u00A0\u2022\u00A0\u00A0\u00A0';
      bar.innerHTML = '<div class="offer-sticky-urgency__track" style="color:#fff !important">' +
        '<span style="color:#fff !important">' + msg + '</span>' +
        '<span style="color:#fff !important">' + msg + '</span>' +
        '</div>';
      document.body.prepend(bar);
      document.body.classList.add('offer-body--has-sticky-bar');
    })();

    /* --- 10. Per-Day Price Anchoring --- */
    (function() {
      function injectPerDay() {
        tierCards.forEach(function(card) {
          var pricingEl = card.querySelector('.offer-tiers__pricing');
          if (!pricingEl) return;
          var existing = card.querySelector('.offer-perday');
          var priceStr = currentMode === 'subscribe'
            ? (card.dataset.subPrice || '')
            : (card.dataset.onePrice || '');
          var numMatch = priceStr.match(/[\d.]+/);
          if (!numMatch) return;
          var perDay = (parseFloat(numMatch[0]) / 30).toFixed(2);
          var html = '\u2615 That\'s only <strong>$' + perDay + '/day</strong> — less than your morning coffee';
          if (existing) {
            existing.innerHTML = html;
          } else {
            var el = document.createElement('div');
            el.className = 'offer-perday';
            el.innerHTML = html;
            pricingEl.parentNode.insertBefore(el, pricingEl.nextSibling);
          }
        });
      }
      injectPerDay();
      // Re-run when mode toggles
      var origModeLink = document.querySelector('.offer-tiers__onetime-link');
      if (origModeLink) {
        origModeLink.addEventListener('click', function() {
          setTimeout(injectPerDay, 50);
        });
      }
    })();

    /* --- 11. "Most Customers Choose This" Badge --- */
    (function() {
      var featured = document.querySelector('.offer-tiers__card--featured');
      if (!featured) return;
      var header = featured.querySelector('.offer-tiers__card-header');
      if (!header) return;
      var badge = document.createElement('div');
      badge.className = 'offer-social-badge';
      badge.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:4px"><rect x="3" y="12" width="4" height="9"/><rect x="10" y="7" width="4" height="14"/><rect x="17" y="3" width="4" height="18"/></svg>73% of customers choose this plan';
      header.parentNode.insertBefore(badge, header.nextSibling);
    })();

    /* --- 12. Dynamic Savings Highlight --- */
    (function() {
      function updateSavings() {
        var selected = getSelectedCard();
        if (!selected) return;
        var ctaBtn = document.getElementById('offer-tiers-cta');
        if (!ctaBtn) return;
        var currentStr = currentMode === 'subscribe'
          ? (selected.dataset.subPrice || '')
          : (selected.dataset.onePrice || '');
        var originalStr = currentMode === 'subscribe'
          ? (selected.dataset.subOriginal || '')
          : (selected.dataset.oneOriginal || '');
        var curMatch = currentStr.match(/[\d.]+/);
        var origMatch = originalStr.match(/[\d.]+/);
        if (!curMatch || !origMatch) return;
        var saved = (parseFloat(origMatch[0]) - parseFloat(curMatch[0])).toFixed(2);
        if (parseFloat(saved) <= 0) return;
        var existing = document.querySelector('.offer-savings-highlight');
        var isBestValue = selected.dataset.tierIndex && parseInt(selected.dataset.tierIndex, 10) === (tierCards.length - 1);
        var html = '<span class="offer-savings-highlight__check">\u2714</span> You save <strong>$' + saved + '!</strong>';
        if (isBestValue) html += ' <span class="offer-savings-highlight__best">\u2728 BEST DEAL</span>';
        if (existing) {
          existing.innerHTML = html;
          existing.classList.remove('offer-savings-highlight--pop');
          void existing.offsetWidth;
          existing.classList.add('offer-savings-highlight--pop');
        } else {
          var el = document.createElement('div');
          el.className = 'offer-savings-highlight offer-savings-highlight--pop';
          el.innerHTML = html;
          ctaBtn.parentNode.insertBefore(el, ctaBtn.nextSibling);
        }
      }
      // Run on load + on tier selection + mode toggle
      updateSavings();
      tierCards.forEach(function(card) {
        card.addEventListener('click', function() {
          setTimeout(updateSavings, 30);
        });
      });
      var mLink = document.querySelector('.offer-tiers__onetime-link');
      if (mLink) {
        mLink.addEventListener('click', function() {
          setTimeout(updateSavings, 50);
        });
      }
    })();

    /* --- 13. Scroll-Depth Discount Nudge --- */
    (function() {
      if (sessionStorage.getItem('offer_scroll_nudge_shown')) return;
      var nudgeShown = false;
      var nudgeEl = null;
      function createNudge() {
        nudgeEl = document.createElement('div');
        nudgeEl.className = 'offer-scroll-nudge';
        nudgeEl.innerHTML = '<button class="offer-scroll-nudge__close">&times;</button>' +
          '<div class="offer-scroll-nudge__emoji">\uD83E\uDD14</div>' +
          '<p class="offer-scroll-nudge__text">Still deciding? You\'re about to miss <strong>40% off + free gifts!</strong></p>' +
          '<a href="#offer-tiers" class="offer-scroll-nudge__btn">See Plans \u2192</a>';
        document.body.appendChild(nudgeEl);
        nudgeEl.querySelector('.offer-scroll-nudge__close').addEventListener('click', dismissNudge);
        nudgeEl.querySelector('.offer-scroll-nudge__btn').addEventListener('click', function(e) {
          e.preventDefault();
          dismissNudge();
          var t = document.getElementById('offer-tiers');
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        requestAnimationFrame(function() {
          nudgeEl.classList.add('offer-scroll-nudge--visible');
        });
      }
      function dismissNudge() {
        if (!nudgeEl) return;
        nudgeEl.classList.remove('offer-scroll-nudge--visible');
        setTimeout(function() { if (nudgeEl) nudgeEl.remove(); }, 400);
        sessionStorage.setItem('offer_scroll_nudge_shown', '1');
      }
      // Dismiss if user interacts with tiers
      tierCards.forEach(function(card) {
        card.addEventListener('click', dismissNudge);
      });
      var ctaBtn = document.getElementById('offer-tiers-cta');
      if (ctaBtn) ctaBtn.addEventListener('click', dismissNudge);
      // Scroll check
      window.addEventListener('scroll', function() {
        if (nudgeShown) return;
        var scrollPct = (window.pageYOffset + window.innerHeight) / document.documentElement.scrollHeight;
        if (scrollPct > 0.65) {
          nudgeShown = true;
          createNudge();
        }
      }, { passive: true });
    })();

    /* --- 14. "Selling Fast" Badge Shake --- */
    (function() {
      var featuredCard = document.querySelector('.offer-tiers__card--featured');
      if (!featuredCard) return;
      var badge = featuredCard.querySelector('.offer-badge');
      var stockText = featuredCard.querySelector('.offer-stock-scarcity__text');
      setInterval(function() {
        if (badge) {
          badge.classList.add('offer-badge--shake');
          setTimeout(function() { badge.classList.remove('offer-badge--shake'); }, 600);
        }
        if (stockText) {
          stockText.classList.add('offer-stock-flash');
          setTimeout(function() { stockText.classList.remove('offer-stock-flash'); }, 800);
        }
      }, 45000);
    })();

  });
})();
